import { createFileRoute } from "@tanstack/react-router";
import { ReferralLinkTermination } from "@/pages/referral-link-termination/ReferralLinkTermination";

export const Route = createFileRoute("/partner/referral-link-termination")({
	head: () => ({
		meta: [{ title: "Terminate Referral Link" }],
	}),
	component: ReferralLinkTermination,
});
